<template>
  <sfs-base-table
    :key="tableKey"
    :data-provider="$usersAPI.getUsers"
    provider-key="users"
    :columns="translatedColumns(modelName, columns)"
    :filters="filters"
    :current-page="currentPage"
    :per-page="perPage"
    :show-per-page="showPerPage"
  >
    <template #cell(name)="data">
      <b-link :to="{ name: 'user', params: { id: data.item.id } }">
        {{ data.item.name }}
      </b-link>
    </template>
    <template #cell(email)="data">
      <b-link :href="`mailto:${data.item.email}`">
        {{ data.item.email }}
      </b-link>
    </template>
    <template #cell(phone)="data">
      <b-link :href="`tel:${data.item.phone}`">
        {{ data.item.phone }}
      </b-link>
    </template>
    <template #cell(manager_id)="data">
      <b-link :to="{ name: 'user', params: { id: data.item.manager_id } }">
        {{ data.item.manager ? data.item.manager.name : "" }}
      </b-link>
    </template>
    <template #cell(category)="data">
      <b-badge variant="secondary">
        {{ data.item.category | humanizedFormat | capitalizeFormat }}
      </b-badge>
    </template>
    <template #cell(services_provided)="data">
      <span v-if="data.item.services_provided.length">
        {{ formattedServicesProvided(data.item.services_provided) }}
      </span>
    </template>
    <template #cell(role)="data">
      <b-link
        v-if="data.item.roles && data.item.roles.length"
        v-b-modal="`user-${data.item.id}-permissions`"
        v-b-tooltip.hover
        title="View permissions"
        class="text-primary text-decoration-none"
      >
        <span
          v-for="(role, index) in data.item.roles"
          :key="role.id"
        >
          {{ role.name | humanizedFormat | capitalizeFormat }}<template v-if="index < data.item.roles.length - 1">, </template>
        </span>
      </b-link>
      <span
        v-else
        class="text-muted"
      >—</span>
      <role-permissions-modal
        :modal-id="`user-${data.item.id}-permissions`"
        :user="data.item"
      />
    </template>
    <template #cell(active)="data">
      {{ !data.item.deleted_at ? "Yes" : "No" }}
    </template>
  </sfs-base-table>
</template>

<script>
import RolePermissionsModal from '@/components/shared/RolePermissionsModal.vue';
import urlMixin from '@/mixins/urlMixin';
import tableMixin from '@/mixins/tableMixin';
import translationMixin from '@/mixins/translationMixin';
import { USER_TABLE_DEFAULT_COLUMNS, USER_MODEL_NAME } from '@/constants/users';

export default {
  name: 'UsersTable',
  mixins: [urlMixin, tableMixin, translationMixin],
  components: {
    RolePermissionsModal,
  },
  props: {
    columns: {
      type: Array,
      default: () => USER_TABLE_DEFAULT_COLUMNS,
    },
  },
  data() {
    return {
      modelName: USER_MODEL_NAME,
    };
  },
  methods: {
    formattedServicesProvided(services) {
      return services.map((service) => this.$options.filters.capitalizeFormat(this.$options.filters.humanizedFormat(service))).join(', ');
    },
  }
};
</script>